// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../Config.bs.js";
import * as NetworkUtils from "../../../../../library/utils/NetworkUtils.bs.js";
import * as Logger$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/logger/Logger.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as NetworkV2$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/NetworkV2.bs.js";
import * as InsuranceRepoConfig from "./InsuranceRepoConfig.bs.js";

function fetchInsurancePlanDetails(uuid, auth_token) {
  var requestUrl = Config.Env.getHostName(undefined) + ("/driver/" + uuid + "/health_insurance");
  Logger$Catalyst.trace({
        requestUrl: requestUrl
      });
  Logger$Catalyst.debug({
        payload: uuid
      });
  return NetworkUtils.catchPromiseError(NetworkV2$Catalyst.get(requestUrl, {
                    AUTHTOKEN: auth_token
                  }, undefined, undefined, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(InsuranceRepoConfig.InsurancePlanResponseConverter.execute, result);
                            });
                }), requestUrl);
}

var InsuranceRepo = {
  fetchInsurancePlanDetails: fetchInsurancePlanDetails
};

export {
  InsuranceRepo ,
  
}
/* Config Not a pure module */
